import React from 'react'
import { getFundGoalType } from '../../Helpers/FundUtility'

export default function FundDisclosureFootnotes({ fund }) {
  const fundGoalType = getFundGoalType(fund)
  const footnotes = fund.disclosures.filter((docType) => docType.footnotes)
  let footnote

  if (
    footnotes &&
    footnotes.length > 0 &&
    footnotes[0].footnotes &&
    footnotes[0].footnotes.length > 0
  ) {
    for (const fundType of footnotes[0].footnotes) {
      if (fundType && fundType.type === fundGoalType) {
        footnote = fundType.content
      }
    }
  }

  return (
    <div
      id="footnoteDisclosure"
      className="u-marginBottom1gu"
      dangerouslySetInnerHTML={{ __html: footnote }}
    />
  )
}
